/* eslint-disable no-param-reassign */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProjectInfo } from 'types/project';
import { Statuses } from 'types/quote';
import type { SnackbarProps } from 'components/Snackbar/Snackbar';

import type { RootState } from '../..';

interface ApplicationState {
  initDone: boolean;
  isResetting: boolean;
  isLoading: boolean;
  projectInfo: ProjectInfo | undefined;
  hasError: boolean;
  snackbar?: SnackbarProps;
  statuses?: Statuses;
}

const initialState: ApplicationState = {
  initDone: false,
  isResetting: false,
  isLoading: false,
  projectInfo: undefined,
  hasError: false,
  snackbar: undefined,
};

const slice = createSlice({
  name: 'applicationState',
  initialState,
  reducers: {
    resetApplication: (state) => {
      state.isResetting = true;
    },
    acknowledgeReset: (state) => {
      state.isResetting = false;
    },
    loadingRequired: (state) => {
      state.isLoading = true;
    },
    loadingStopRequired: (state) => {
      state.isLoading = false;
    },
    applicationInitDone: (state) => {
      state.initDone = true;
    },
    applicationProjectInfoLoaded: (state, action: PayloadAction<ProjectInfo>) => {
      state.projectInfo = action.payload;
    },
    setError: (state) => {
      state.hasError = true;
    },
    setSnackbar: (state, action: PayloadAction<SnackbarProps | undefined>) => {
      state.snackbar = action.payload;
    },
    setStatuses: (state, action: PayloadAction<Statuses>) => {
      state.statuses = action.payload;
    },
  },
});

export const getApplicationState = createSelector(
  (state: RootState) => state.applicationState,
  (state) => state,
);

export const applicationStateActions = slice.actions;

export const { reducer } = slice;
